import { translate } from './translation'

export default function () {
  return translate
}
